import * as React from 'react'

import { makeObservable, observable } from 'mobx'

import MessagesStore from '~/client/src/shared/stores/domain/MessagesStore/Messages.store'
import PhotosStore from '~/client/src/shared/stores/domain/Photos.store'
import InitialState from '~/client/src/shared/stores/InitialState'
import CommonStore from '~/client/src/shared/stores/ui/Common.store'

interface IProps {
  photosStore?: PhotosStore
  messagesStore?: MessagesStore
  common?: CommonStore
  state?: InitialState
  match?: any
  photoId?: string
}

export default class PhotoDetailsBase<
  T extends IProps,
> extends React.Component<T> {
  @observable protected isPortrait = true

  public constructor(props: T) {
    super(props)
    makeObservable(this)
  }

  protected get photo() {
    const photoId = this.props.match.params.photoId || this.props.photoId

    return this.props.photosStore.byId.get(photoId)
  }

  protected get caption() {
    if (this.photo) {
      return this.props.messagesStore.byId.get(this.photo.messageId)
    }
  }

  public handleLayout = () => {
    this.isPortrait = !this.isPortrait
  }

  public backClicked = () => {
    this.props.common.displayDefaultView()
  }
}
